export class Configuration {
    public getBasePath: () => { web: string, rest: string };
    public invalidRoles: string[];
    public tokenLogin: boolean = false;
    public tokenRefresh: boolean = true;
    public statusTimeout: number = 1000;
    public getValue: (key: string) => Promise<string> | string = (key: string): string => localStorage.getItem(`${location.pathname.replace('index.html', '')}_${key}`);
    public setValue: (key: string, value: string) => Promise<void> | void = (key: string, val: string): void => {
        if (val != null) {
            localStorage.setItem(`${location.pathname.replace('index.html', '')}_${key}`, val);
        } else {
            localStorage.removeItem(`${location.pathname.replace('index.html', '')}_${key}`);
        }
    };
}
